import type { DataPerspective } from '@/api/hooks/useOrders'
import { InvoicesGrid } from './InvoicesGrid'

interface InvoicesContentProps {
  orderId: string | undefined
  dataPerspective: DataPerspective
}

export function InvoicesContent({
  orderId,
  dataPerspective,
}: InvoicesContentProps) {
  if (!orderId) return null

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        flexGrow: 1,
        minHeight: '100%',
        height: '70vh',
        width: '100%',
      }}
    >
      <InvoicesGrid orderId={orderId} dataPerspective={dataPerspective} />
    </div>
  )
}
